<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form @submit.prevent="submitForm" id="edit-card-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="تعديل معلومات العينة"
          text="يرجى ادخال معلومات العينة =المراد تعديلها و تدقيقها قبل عملية الإرسال"
        >

            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="fullname"
                    readonly
                    disabled
                    label="إسم الطفل الرباعي"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="barcode"
                    readonly
                    disabled
                    class="purple-input"
                    label="رقم العينة"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                >
                  <v-autocomplete
                      :items="healthdeps"
                      v-model="healthdep"
                      label="دائرة الصحة"
                      class="purple-input"
                      required></v-autocomplete>

                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                  v-model="sector"
                    label="القطاع"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                  v-model="healthcenter"
                    label="المركز الصحي"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                  v-model="takenby"
                    label="اسم القائم بأخذ العينة"
                    class="purple-input"/>
                </v-flex>



                <v-flex
                        xs12
                        md4>

                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                              v-on="on"
                              v-model="takendate"
                              class="purple-input"
                              readonly
                              label="تاريخ اخذ العينة"/>

                    </template>
                    <v-date-picker dark v-model="takendate" />
                  </v-menu>
                </v-flex>

                <v-flex
                    xs12
                    md12>
                  <v-autocomplete
                      :items="this.$store.state.checktypes"
                      v-model="status"
                      label="نوع الفحص"
                      class="purple-input"
                  ></v-autocomplete>
                </v-flex>


                  <v-flex
                          xs12
                          md4>
                      <v-checkbox
                              v-model="duplicate"
                              label="عينة مكررة ؟"
                              color="success"
                      />
                  </v-flex>

                  <v-flex
                      xs12
                      md4>
                    <v-checkbox
                        v-model="rejected"
                        label="عينة مرفوضة ؟"
                        color="success"
                    />
                  </v-flex>

                  <v-flex
                        xs12
                        md4>
                  <v-text-field
                            v-model="duplicatereason"
                          class="purple-input"
                          label="سبب تكرار العينة"/>
                </v-flex>

              </v-layout>
            </v-container>

        </material-card>
      </v-flex>

      <v-flex
              xs12
              md4
      >

        <material-card
                color="orange"
                title="نتائج فحص Galactosemia"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="gal.sttg"
                        prefix="mg/dL"
                        label="Screening Test - t. Glactose"
                />
                <v-text-field
                        v-model="gal.cttg"
                        prefix="mg/dL"
                        label="Confirmation - t.Glactose"
                />
                <v-text-field
                        v-model="gal.ctgalt"
                        prefix="U/g Hb"
                        label="Confirmation GALT"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

        <material-card
                color="purple"
                title="نتائج فحص PKU"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="pku.stph"
                        prefix="mg/dL"
                        label="Screening test - Phenylalanine"
                />
                <v-text-field
                        v-model="pku.ctph"
                        prefix="μM"
                        label="Confirmation - Phenylalanine"
                />
                <v-text-field
                        v-model="pku.ctty"
                        prefix="μM"
                        label="Confirmation - Tyrosine"
                />
                <v-text-field
                        v-model="pku.ctpr"
                        label="Confirmation - PiT Ratio"
                />

              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

        <material-card
                color="blue"
                title="نتائج فحص CHT"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="cht.sttsh"
                        prefix="mg/dL"
                        label="Screening test - TSH"
                />
                <v-text-field
                        v-model="cht.cttsh"
                        prefix="μU/ml"
                        label="Confirmation - TSH"
                />
                <v-text-field
                        v-model="cht.ctfty"
                        prefix="pmol/L"
                        label="Confirmation FTY"
                />
              </v-flex>
            </v-layout>


          </v-container>

        </material-card>
        <v-btn @click="deleteItem()" color="danger">
          <v-icon class="ml-2">mdi-delete</v-icon>
          حذف العينة
        </v-btn>


      </v-flex>


          <v-flex
                  md12
                  xs12
                  text-xs-right
                    >
                    <v-btn
                     type="submit" form="edit-card-form"
                    class="mx-0 font-weight-bold"
                    color="success"
                    >
             حفظ التغييرات
            </v-btn>
          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Axios from 'axios'
import {__GET_AS_LIST,__HTTP,FormHeader,__HAS_PERM} from '@/utils/utils'


  export default {
    data: () => ({
      gal: {
        sttg: '',
        cttg: '',
        ctgalt: ''
      },
      pku: {
        stph: '',
        ctph: '',
        ctpr: '',
        ctty: ''
      },
      cht: {
        sttsh: '',
        cttsh: '',
        ctfty: ''
      },
      picker: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      barcode: '',
      healthcenter: '',
      sector: '',
      healthdep: '',
      takenby: '',
      takendate: '',
      duplicatereason: '',
      duplicate: '',
      rejected: '',
      fullname: '',
      status: '',
      healthdeps: [],
      id: null
    }),
    created() {
      this.getCardInfo();
      this.getHealthDep();

    },
    methods: {
      getHealthDep() {
        __GET_AS_LIST("healthdep",{},(res) => {
          res.map((i) => {
            // console.log("xcxcx",i);
            this.healthdeps.push({text: i.title, value:i.id});
          });
        });
      },
      deleteItem() {
        let c = confirm('هل انت متأكد من حذف هذه العينة ؟');
        if (c) {
          __HAS_PERM(40,this.$store.state.loggedUser.id,() => {
            __HTTP("?do=delete",{type: "card",id: this.id},FormHeader,() => {
              this.$router.push({path: '/list-patients'})
            })
          });
        }
      },
      getCardInfo() {
        Axios.post("https://cphl.esite-lab.com/api.php?do=getcardinfo&id="+this.$route.query.pid).then((res) =>{
          if (res.data.auth == true) {
            this.id = res.data.id
            this.fullname = res.data.fullname
            this.barcode = res.data.barcode
            this.healthcenter = res.data.healthcenter
            this.healthdep = res.data.healthdep
            this.sector = res.data.healthsector
            this.takenby = res.data.takenby
            this.takendate = res.data.takendate
            this.duplicate = res.data.duplicate === 1
            this.status = res.data.status
            this.rejected = res.data.rejected === 1
            this.duplicatereason = res.data.duplicatereason
            this.gal = {
                  sttg: res.data.gal.sttg,
                  cttg: res.data.gal.cttg,
                  ctgalt: res.data.gal.ctgalt
                }
            this.pku = {
              stph: res.data.pku.stph,
              ctph: res.data.pku.ctph,
              ctpr: res.data.pku.ctpr,
              ctty: res.data.pku.ctty
            }
            this.cht = {
              sttsh: res.data.cht.sttsh,
              cttsh: res.data.cht.cttsh,
              ctfty: res.data.cht.ctfty
            }

          }
        })
      },
      submitForm() {

        Axios.post("https://cphl.esite-lab.com/api.php?do=editcard",{
            barcode: this.barcode,
            healthcenter: this.healthcenter,
            healthsector: this.sector,
            healthdep: this.healthdep,
            takenby: this.takenby,
            takendate: this.takendate,
            duplicatereason: this.duplicatereason,
            duplicate: this.duplicate ? 1 : 0,
            status: this.status,
            rejected: this.rejected ? 1 : 0,
            patientid: this.patientid,
            id: this.id,
            gal: this.gal,
            pku: this.pku,
            cht: this.cht
        }, {
          headers: {
            'Content-Type': "application/x-www-form-urlencoded"
          }
        }).then((res) => {
          console.log(res.data)
            if (res.data.auth == true) {
              this.$router.push({path: '/list-patients'})
            }
        })
      }
    }
  }
</script>
